// components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="bg-grafito text-white py-4 px-6 fixed w-full z-50 shadow-md">
            <div className="container mx-auto flex justify-between items-center">
                {/* Logo */}
                <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 400" className="h-16 w-auto mr-2" >
                        <defs>
                            <linearGradient id="bgGradient" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#2C2B3D" />
                                <stop offset="100%" stopColor="#3A3A52" />
                            </linearGradient>
                        </defs>
                        <rect  rx="15" fill="url(#bgGradient)" />
                        <path d="M250 190            C270 160, 310 120, 350 110            C380 105, 400 125, 410 155            C420 185, 430 210, 440 225            C450 240, 460 240, 465 225" fill="none" stroke="#F27D8C" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
                        <text x="145" y="270" font-family="Montserrat, Poppins, Arial, sans-serif" font-size="68" font-weight="600" fill="white" letter-spacing="-1">
                            Iron <tspan font-weight="700">five</tspan>
                        </text>
                    </svg>
                </div>

                {/* Desktop Navigation */}
                <nav className="hidden md:block">
                    <ul className="flex space-x-4 lg:space-x-6 font-montserrat">
                        <li><Link to="/#quienes-somos" className="hover:text-cyan transition-colors text-sm lg:text-base">Quiénes somos</Link></li>
                        <li><Link to="/#servicios" className="hover:text-cyan transition-colors text-sm lg:text-base">Servicios</Link></li>
                        <li><Link to="/#metodologia" className="hover:text-cyan transition-colors text-sm lg:text-base">Metodología</Link></li>
                        <li><Link to="/portafolio" className="hover:text-cyan transition-colors text-sm lg:text-base">Trabajos Realizados</Link></li>
                        <li><Link to="/#contacto" className="hover:text-cyan transition-colors text-sm lg:text-base">Contacto</Link></li>
                    </ul>
                </nav>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden flex flex-col justify-center items-center w-6 h-6 relative"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? 'rotate-45 translate-y-1' : '-translate-y-1'}`}></span>
                    <span className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm my-0.5 ${isMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                    <span className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? '-rotate-45 -translate-y-1' : 'translate-y-1'}`}></span>
                </button>
            </div>

            {/* Mobile Navigation Menu */}
            <div className={`md:hidden absolute top-full left-0 w-full bg-grafito shadow-lg transition-all duration-300 ease-in-out ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                <nav className="py-4 px-6">
                    <ul className="flex flex-col space-y-4 font-montserrat">
                        {[
                            { to: '/#quienes-somos', label: 'Quiénes somos' },
                            { to: '/#servicios', label: 'Servicios' },
                            { to: '/#metodologia', label: 'Metodología' },
                            { to: '/portafolio', label: 'Trabajos Realizados' },
                            { to: '/#contacto', label: 'Contacto' },
                        ].map((item, i, arr) => (
                            <li key={item.to}>
                                <Link
                                    to={item.to}
                                    className={`block py-2 hover:text-cyan transition-colors ${i < arr.length - 1 ? 'border-b border-gray-600' : ''}`}
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
